<div class="common-lateral-panel"
  [ngClass]="{'common-lateral-panel--expand':boxCommunicationChannel.fullScreen && !boxCommunicationChannel.showCommentBox,
    'common-lateral-panel--expand-text-comment':boxCommunicationChannel.fullScreen && boxCommunicationChannel.showCommentBox,
    'common-lateral-panel--no-content':!boxCommunicationChannel.commentList.length && !boxCommunicationChannel.showCommentBox
  }">
  <div class="common-section-title__lp-container">
    <div class="common-section-title__lp-title-icon">
      <i class="lf-icon-communication common-icon__lg"
      [ngClass]="{'common-icon__main': !isLanding}"></i>
      <span class="common-section-title__lp-label-text"
        [afTranslate]="'box-comunication-channel.message-system'">_Sistema de mensajería</span>
    </div>
    <div class="common-section-title__dp-buttons-container">
      @if (boxCommunicationChannel.unreadAmount > 0) {
        <i class="lf-icon-chat common-special-icon__notification-md">
          <span class="common-special-icon__count-notification-md">{{boxCommunicationChannel.unreadAmount}}</span>
        </i>
      }
      @if (!boxCommunicationChannel.disabledActions) {
        <button class="common-button__icon-md-noborder"
          [disabled]="lockComToManager || boxCommunicationChannel.showCommentBox"
          (click)="newComment()"
          pTooltip="{{'box-comunication-channel.new-message' | afTranslate}}"
          tooltipPosition="top"
          [tooltipDisabled]="lockComToManager || boxCommunicationChannel.showCommentBox">
          <i class="lf-icon-add-round common-icon__md"></i>
        </button>
      }
    </div>
  </div>
  @if (lockComToManager){
    <div class="common-status-message__s-container-warning">
      <span class="common-status-message__s-title"
        [afTranslate]="'box-comunication-channel.no-permissions-to-add'">
        _No puedes enviar nuevos mensajes en este punto del proceso de la comunicación.</span>
    </div>
  }
  <div class="common-lateral-panel__body"
    [ngClass]="{'common-lateral-panel__body--no-content': !boxCommunicationChannel.commentList.length && !boxCommunicationChannel.showCommentBox}"
    [id]="'box-communication-channel-'+boxCommunicationChannel.id">
    @if (boxCommunicationChannel.showCommentBox){
      <div class="common-lateral-panel__body-new-comment">
        <div class="common-lateral-panel__body-new-header">
          <div class="common-lateral-panel__body-new-header-title">
            <div class="common-badge__block-dot-md">
              <div class="common-badge__dot-xs-main-1000"></div>
            </div>
            <p class="common-lateral-panel__body-new-title-text"
              [afTranslate]="'box-comunication-channel.new-message'">_Nuevo mensaje
            </p>
          </div>
          <div class="common-lateral-panel__audio-block">
            @if (boxCommunicationChannel.hasVoiceRecord) {
              <div class="common-lateral-panel__audio-title-container">
                <button class="common-button__link"
                  (click)="listenVoiceRecord()">
                  <span class="common-button__link-text">{{boxCommunicationChannel.voiceRecord.name}}</span>
                </button>
              </div>
            }
            <button class="common-button__icon-md-noborder"
              [ngShow]="skin === 'dark-blue' || skin === 'gm-law'"
              (click)="openRecordVoice()">
              <i class="lf-icon-microphone common-icon__md"></i>
            </button>
          </div>
        </div>
        <label for="comment-text-area"
          class="common-lateral-panel__new-comment-block">
          <textarea id="comment-text-area"
            class="common-lateral-panel__new-comment-textarea"
            autocomplete="off"
            [placeholder]="'customize.voice-record-text-default' | afTranslate"
            [(ngModel)]="boxCommunicationChannel.commentText">
          </textarea>
        </label>
        <div class="common-lateral-panel__buttons-container">
          <button class="common-button__text-little-border"
            [disabled]="boxCommunicationChannel.disabledButtons"
            (click)="closeComment()">
            <span class="common-button__text-little-title"
              [afTranslate]="'common.cancel'">_Cancelar</span>
          </button>
          <button class="common-button__text-little"
            [disabled]="boxCommunicationChannel.disabledButtons"
            (click)="createNewComment(boxCommunicationChannel.commentText)">
            <span class="common-button__text-little-title"
            [afTranslate]="'common.send'">_Enviar</span>
          </button>
        </div>
      </div>
    }
    @if (boxCommunicationChannel.commentListFilter?.length) {
      <div class="common-lateral-panel__inner-body">
        @for (comment of boxCommunicationChannel.commentListFilter | afOrderBy:'creationDate':true | afLimitTo:boxCommunicationChannel.fullScreen?boxCommunicationChannel.commentListFilter.length:1; track $index) {
          <div class="common-lateral-panel__message-container">
            <div class="common-lateral-panel__message-container-header"
              [ngClass]="{'common-lateral-panel__message-container-header--applicant': comment.applicantMessage}">
              <div class="common-lateral-panel__message-container-header-left"
                [ngClass]="{'common-lateral-panel__message-container-header-left--applicant': comment.applicantMessage}">
                <div class="common-badge__block-dot-md">
                  <div class="common-badge__dot-xs-main-1000"></div>
                </div>
                <div class="common-lateral-panel__message-specific-data-block"
                  [ngClass]="{'common-lateral-panel__message-specific-data-block--applicant': comment.applicantMessage}">
                  <div class="common-lateral-panel__message-client-container">
                    <div class="common-lateral-panel__message-client-content">
                      <p class="common-lateral-panel__message-client-text-strong"
                        [afTranslate]="comment.managerMessage?'box-comunication-channel.manager':'box-comunication-channel.applicant'"></p>
                    </div>
                    @if (comment.unreadForUser) {
                      <div [ngClass]="isLanding?'common-tag__new-filled':'common-tag__new'">
                        <span class="common-tag__new-bullet"></span>
                        <span class="common-tag__new-label-text"
                          [afTranslate]="'common.new'">_Nuevo</span>
                      </div>
                    }
                  </div>
                  <div class="common-lateral-panel__message-client-date">
                    @if (comment.showAudioRecord && !boxCommunicationChannel.conceptanonymized) {
                      <i class="lf-icon-sound common-icon__sm-code-color-neutral-grey-800"></i>
                    }
                    <p class="common-lateral-panel__message-client-date-container">
                      <span class="common-lateral-panel__message-client-date-text">{{comment.creationDate | convertDate: 'without-time' }}</span>
                    </p>
                    <p class="common-lateral-panel__message-client-date-container">
                      <span class="common-lateral-panel__message-client-date-text">{{comment.creationDate | convertDate: 'only-time' }}</span>
                    </p>
                  </div>
                  @if (!isLanding && boxCommunicationChannel.skinsAccepted && comment.readTime && comment.managerMessage) {
                    <div class="common-lateral-panel__message-client-info-read">
                      <p class="common-lateral-panel__message-client-date-text-applicant">
                        <span [afTranslate]="'box-comunication-channel.message-read'">_Leido por el Solicitante el </span>
                        <span>{{ comment.readTime | convertDate:'without-time'}}</span> -
                        <span>  {{ comment.readTime | convertDate:'only-time'}}</span>
                      </p>
                      <i class="lf-icon-visible common-icon__sm common-icon__main-600"></i>
                    </div>
                  }
                </div>
              </div>
              @if (comment.unreadForUser) {
                <button class="common-lateral-panel__button-action"
                  (click)="markAsRead(comment)"
                  pTooltip="{{'box-comunication-channel.check-read' | afTranslate}}"
                  tooltipPosition="top">
                  <i class="lf-icon-check-round common-icon__md"></i>
                </button>
              }
            </div>
            <div class="common-lateral-panel__message-text-block">
              <div class="common-lateral-panel__message-inner-text"
                [innerHTML]="comment.commentText">
              </div>
              @if(comment.showAudioRecord && !boxCommunicationChannel.concept.anonymized){
                <div class="common-lateral-panel__audio-title-container">
                  <button class="common-button__link"
                    (click)="listenVoiceRecord(comment)">
                    <span class="common-button__link-text">{{comment.name}}</span>
                  </button>
                </div>
              }
              @if(comment.audioFileName != null && boxCommunicationChannel.concept.anonymized){
                <div class="field-type-text__transcription-block field-type-text__transcription-block--box-communication">
                  <p class="field-type-text__transcription-text field-type-text__transcription-text--box-communication"
                    [afTranslate]="'record-audio-modal.audio-transcription'"></p>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }@else if (!boxCommunicationChannel.showCommentBox) {
      <p class="common-lateral-panel__no-content"
        [afTranslate]="'box-comunication-channel.no-messages-between'">
        __No hay mensajes entre el informante y el responsable del canal
      </p>
    }
  </div>
  @if(!(!boxCommunicationChannel.fullScreen && boxCommunicationChannel.showCommentBox) && boxCommunicationChannel.commentList.length){
    <div class="common-lateral-panel__expand-block">
      <div class="common-lateral-panel__expand-left-block">
        <div class="common-lateral-panel__expand-total-block">
          <p class="common-lateral-panel__expand-total-text">
            <span [afTranslate]="'common.total'">_Total</span>
            <span class="pr-1">:</span>
            <span>{{boxCommunicationChannel.commentListFilter?.length}}</span>
          </p>
        </div>
        @if (!isLanding && boxCommunicationChannel.commentListFilter?.length){
          <button class="common-button__icon-md-noborder"
            (click)="downloadPdf()"
            pTooltip="{{'box-comunication-channel.download-pdf' | afTranslate}}"
            tooltipPosition="top"
            [tooltipDisabled]="boxCommunicationChannel.showCommentBox">
            <i class="lf-icon-download common-icon__md"></i>
          </button>
        }
      </div>

        <button class="common-button__expand-toned"
          (click)="boxCommunicationChannel.fullScreen = !boxCommunicationChannel.fullScreen">
          <i class=" common-icon__md"
            [ngClass]="boxCommunicationChannel.fullScreen? 'lf-icon-angle-up': 'lf-icon-angle-down'"></i>
          <span class="common-button__expand-label-text"
            [afTranslate]="boxCommunicationChannel.fullScreen?'common.collapse':'common.expand'"></span>
        </button>

    </div>
  }
</div>


<div class="common__pdf-hidde-element">
  <div [id]="'pdf-historic-communication-channel'">
    <pdf-header
      [pdfInfo]="boxCommunicationChannel.pdfInfo"
      [datePdf]="boxCommunicationChannel.configPdf?.exportDate"></pdf-header>
    <div class="common__pdf-body-figma">
      <div class="common__pdf-title-block-figma">
          <span>{{concept.evaluationName}}</span>
      </div>
      <div class="box-comunication-channel__container-list-pdf">
        @for (commentPdf of boxCommunicationChannel.commentListFilter | afOrderBy:'creationDate':true; track $index){
          <div class="box-comunication-channel__element-list-pdf">
            <div class="box-comunication-channel__element-header-pdf">
              <span class="box-comunication-channel__element-manager-pdf"
                [afTranslate]="commentPdf.managerMessage?'box-comunication-channel.manager':'box-comunication-channel.applicant'"></span>
              <span>{{commentPdf.creationDate | convertDate: 'without-time-and-hour' }}</span>
              @if (boxCommunicationChannel.skinsAccepted && commentPdf.readTime !== null && commentPdf.managerMessage) {
                <p class="box-comunication-channel__read-by">
                  <span [afTranslate]="'box-comunication-channel.message-read'"></span>
                  <span>{{ commentPdf.readTime | convertDate:'without-time-and-hour'}} h</span>
                </p>
              }
            </div>
            <div class="box-comunication-channel__element-message-pdf">
              " <span [innerHTML]="commentPdf.commentText"></span> "
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
